import { Stack } from "@mui/material";
import { omit } from "lodash-es";
import { useMemo, type FC } from "react";
import { prettyChannelName } from "../../../../channels/utils";
import { AdditionalRecipientsDatagrid } from "./components/additional-recipients-datagrid";
import { PreviewPersonsButton } from "./components/preview-persons-button";
import { PreviewTooltip } from "./components/preview-tooltip";
import type { PreviewProps } from "./types";
import { subjectToChange } from "./utils";

export const ChannelPreview: FC<PreviewProps<"channel">> = ({
  preview_config,
  channel,
  ...rest
}) => {
  const channelName = prettyChannelName(channel);
  const channelLabel = preview_config.data.channels === 1 ? "channel" : "channels";
  const peopleLabel = preview_config.data.channels === 1 ? "person" : "people";
  const buttonText = `${channelName} channels: `;

  const title = useMemo(() => {
    const base = `${preview_config.data.channels} ${channelName} ${channelLabel}`;

    if (preview_config.data.segment)
      return (
        `${base} ` +
        `${preview_config.data.channels} ${peopleLabel} in the segment.` +
        subjectToChange
      );

    return base;
  }, [
    channelLabel,
    channelName,
    peopleLabel,
    preview_config.data.channels,
    preview_config.data.segment,
  ]);

  return (
    <>
      <Stack direction="column" alignItems="flex-end" {...omit(rest, "data")}>
        <Stack direction="row" spacing={2} alignItems="center">
          <PreviewPersonsButton
            persons={preview_config.data.channels}
            channel={channel}
            buttonText={buttonText}
          >
            <AdditionalRecipientsDatagrid
              channel={channel}
              recipientIds={preview_config.data.channel_ids}
              targetChannel={true}
            />
          </PreviewPersonsButton>

          <PreviewTooltip title={title} />
        </Stack>
      </Stack>
    </>
  );
};
